import { render } from "./SearchSection.vue?vue&type=template&id=7061585e&scoped=true"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"

import "./SearchSection.vue?vue&type=style&index=0&id=7061585e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7061585e"]])

export default __exports__